<template>
  <div>
    <div>
      <div v-if="active==0">
        <!--用户信息-->
        <div class="page">
          <div class="top">
            <van-image width="54" height="54" :src="userInfo.avatar">
              <template v-slot:error>加载失败</template>
            </van-image>
          </div>
          <div class="text">
            <div>{{ userInfo.nickName }}</div>
            <div class="text-bottom">{{userInfo.dept.deptName }}</div>
          </div>
        </div>
        <!-- 内容 :style="setHeight" -->
        <div class="p-l-10 p-r-10 p-b-26" style="padding-top: 2.8rem;" ref="myDiv">
           <div class="page-content "  style="margin-top: 0;">
            <div class="title">看板</div>
            <van-row>
              <van-col span="6" v-for="(item,index) in boardList" :key="index" @click="goPageKeep(item.path,index)">
                <van-badge>
                  <img class="icon" :src="item.iconSrc">
                </van-badge>
                <div class="icon-text">{{ item.text }}</div>
              </van-col>
            </van-row>
          </div>
          <div class="page-content">
            <div class="title">我的工作</div>
            <van-row>
              <van-col span="6" v-for="(item,index) in workIconList" :key="index" @click="goPageKeep(item.path,index)">
                <van-badge>
                  <img class="icon" :src="item.iconSrc">
                </van-badge>
                <div class="icon-text">{{ item.text }}</div>
              </van-col>
            </van-row>
          </div>
          <div class="page-content">
            <div class="title">日常办公</div>
            <van-row>
              <van-col span="6" v-for="(item,index) in examineList" :key="index" @click="goPage(item)">
                <van-badge>
                  <img class="icon" :src="item.examineIcon">
                </van-badge>
                <div class="icon-text">{{ dataSize[item.groupId] }}</div>
                <!--              <div class="icon-text h-65 ellipsis-2">{{ item.remark }}</div>-->
              </van-col>
            </van-row>
          </div>
          <div class="page-content">
            <div class="title">项财CRM</div>
            <van-row>
              <van-col span="6" v-for="(item,index) in itemMaterialList" :key="index" @click="goPageKeep(item.path)">
                <van-badge>
                  <img class="icon" :src="item.iconSrc">
                </van-badge>
                <div class="icon-text">{{ item.text }}</div>
              </van-col>
            </van-row>
          </div>
          <div class="page-content">
            <div class="title">其他</div>
            <van-row>
              <van-col span="6" v-for="(item,index) in otherList" :key="index" @click="goPageKeep(item.path)">
                <van-badge>
                  <img class="icon" :src="item.iconSrc">
                </van-badge>
                <div class="icon-text">{{ item.text }}</div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <div v-if="active==1">
        <myWork />
      </div>
    </div>
    <van-tabbar v-model="active" @change="onChange" fixed :placeholder="true" :safe-area-inset-bottom="true">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="apps-o">我的工作</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script >

import { mapMutations, mapState } from "vuex";
import myWork from '@/views/myWork/index.vue'
import {getUseFlows, taskRevoke} from "@/api/flow";
import cache from '@/plugins/cache'

export default {
  components: {
    myWork
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    }),
    setHeight(){
      return 'height:'+ (document.documentElement.clientHeight + 50) + 'px'
    }
  },
  data () {
    return {
      tabIndex: 0,  // 当前选中的 tab 索引
      active: 0,
       boardList: [{
        iconSrc: require('@/assets/icon/u85.png'),
        text: '员工看板',
        path: '/employeeKanban',
      },
      {
        iconSrc: require('@/assets/icon/u87.png'),
        text: '经营可视化看板',
        path: '/operateKanban',
      }
    ],
      workIconList: [{
        iconSrc: require('@/assets/icon/u49.png'),
        text: '我的待办',
        path: '/myWork',
      },
      {
        iconSrc: require('@/assets/icon/u40.png'),
        text: '我的已办',
        path: '/myWork',
      },
      {
        iconSrc: require('@/assets/icon/u33.png'),
        text: '我发起的',
        path: '/myWork',
      }, {
        iconSrc: require('@/assets/icon/u36.png'),
        text: '抄送我的',
        path: '/myWork',
      }, {
          iconSrc: require('@/assets/icon/u37.png'),
          text: '重置密码',
          path: '/userInfo',
        }
      ],
      itemMaterialList: [{
        iconSrc: require('@/assets/icon/u45.png'),
        text: '客户管理',
        path: '/client',
      },
      {
        iconSrc: require('@/assets/icon/u49.png'),
        text: '拜访记录',
        path: '/visitList',
      },
      ],
      otherList: [{
        iconSrc: require('@/assets/icon/u84.png'),
        text: '我的任务',
        path: '/taskList',
      },
      {
        iconSrc: require('@/assets/icon/u86.png'),
        text: '反馈统计',
        path: '/feedbackStatistics',
      }
      ],
      examineList: [],
      examineIcon: {
        5: require('@/assets/icon/u55.png'),//报销
        6: require('@/assets/icon/u63.png'),//采购
        7: require('@/assets/icon/u72.png'),//开票
        8: require('@/assets/icon/u60.png'),//请假
        9: require('@/assets/icon/u58.png'),//用印
        10: require('@/assets/icon/u78.png'),//离职
        11: require('@/assets/icon/u67.png'),//出差
        17: require('@/assets/icon/u69.png'),//付款
        26: require('@/assets/icon/u75.png'),//差旅报销
        31: require('@/assets/icon/u87.png'),//划账
      },
      dataSize: {
        5: "报销",
        6: "采购",
        7: "开票",
        8: "请假",
        9: "用印",
        10: "离职",
        11: "出差",
        17: "付款",
        26: "差旅报销",
        31: "划账",
      },
    }
  },
  created () {
    this.userInfo = JSON.parse(cache.session.get("userInfo"))
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active);
    }
    this.getList()
  },
  mounted () {
    console.log('-myWork--historyEntries---',this)
    console.log('-myWork--historyEntries---',this.$router)
    console.log('-myWork--historyEntries--history-',history)
    // 假设你有一个 Vue Router 实例名为 router
    // const historyEntries = router.history.stack; // 获取历史记录栈
    // console.log('---historyEntries---',historyEntries); // 打印历史记录栈
    history.pushState(null, null, document.URL)
    this.SET_PROCESS_INSTANCE_ID('')
    window.addEventListener('popstate', this.handleBackButton);
    console.log('this.$refs.myDiv.offsetHeight----', this.$refs.myDiv.offsetHeight + 50);
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.handleBackButton);
  },
  methods: {
    ...mapMutations({
      SET_PROCESS_INSTANCE_ID: 'process/SET_PROCESS_INSTANCE_ID',
    }),
    getList () {
      getUseFlows().then(res => {
        let list = res.data
        this.examineList = list.reduce((acc, current) => {
          // 只返回特定的内容
          const isDuplicate = acc.some(item => item.groupId === current.groupId);
          // 如果不存在相同的 templateName，则添加到结果数组中
          if (!isDuplicate) {
            current.examineIcon = this.examineIcon[current.groupId]
            if (current.examineIcon) {

              current.remark = current.templateName
              acc.push(current);
            }
          }
          return acc;
        }, []);
      })
    },
    //  点击跳转页面/权限页面
    goPage (item) {
      console.log(item)
      const routerPathGroupId = this.$router.options.routes.find(rourer => {
        return rourer?.meta?.groupId == item.groupId
      })
      if (routerPathGroupId) {
        this.$router.push({ path: `/flowRedirect?groupId=${item.groupId}&templateId=${item.templateId}` })
      }
    },
    // 点击跳转我的工作页面显示不同tab
    goPageKeep (path, index) {
      this.$router.push({ path, query: { tabIndex: index } }); // 传递 tabIndex 参数
    },

    // tab切换
    onChange (index) {
      this.active = index;
    },

    // 关闭浏览器
    handleBackButton (event) {
      window.close()
      window.WeixinJSBridge.call('closeWindow');
    }
  },
}
</script>

<style scoped lang="less">
.title {
  font-size: 28px;
  font-weight: 600;
  padding: 0.36667rem 0;
  padding-left: 0.4rem;
  color: #33334d;
}
.icon {
  width: 1.3rem;
}
.icon-text {
  font-size: 0.299rem;
  padding-top: 7px;
}
.center {
  margin: 220px 0;
  margin-top: 2.3rem;
}
.page {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100vw;
  padding: 35px;
  display: flex;
  align-items: center;
  background-color: #4f92f7;
  .text {
    color: #fff;
    margin-left: 20px;
    font-size: 28px;
    .text-bottom {
      margin-bottom: 5px;
      margin-top: 10px;
      font-size: 20px;
      letter-spacing: 1px;
    }
  }
}
.page-content {
  width: 97vw;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  margin-top: 10px;
  will-change: transform;
  backface-visibility: hidden; /* 提高GPU渲染 */
  -webkit-overflow-scrolling: touch; /* iOS 弹性滚动 */
  ::v-deep .van-col--6 {
    text-align: center;
    padding-bottom: 20px;
  }
}
</style>
